function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { getBreakpoint, getFragmentFromUrl } from '../../common/index.mjs';
import { ElementError } from '../../errors/index.mjs';
import { GOVUKFrontendComponent } from '../../govuk-frontend-component.mjs';

/**
 * Tabs component
 *
 * @preserve
 */
var Tabs = /*#__PURE__*/function (_GOVUKFrontendCompone) {
  /**
   * @param {Element | null} $module - HTML element to use for tabs
   */
  function Tabs($module) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _callSuper(this, Tabs);
    _this.$module = void 0;
    _this.$tabs = void 0;
    _this.$tabList = void 0;
    _this.$tabListItems = void 0;
    _this.jsHiddenClass = 'govuk-tabs__panel--hidden';
    _this.changingHash = false;
    _this.boundTabClick = void 0;
    _this.boundTabKeydown = void 0;
    _this.boundOnHashChange = void 0;
    _this.mql = null;
    if (!$module) {
      throw new ElementError({
        componentName: 'Tabs',
        element: $module,
        identifier: 'Root element (`$module`)'
      });
    }
    var $tabs = $module.querySelectorAll('a.govuk-tabs__tab');
    if (!$tabs.length) {
      throw new ElementError({
        componentName: 'Tabs',
        identifier: 'Links (`<a class="govuk-tabs__tab">`)'
      });
    }
    _this.$module = $module;
    _this.$tabs = $tabs;
    _this.boundTabClick = _this.onTabClick.bind(_this);
    _this.boundTabKeydown = _this.onTabKeydown.bind(_this);
    _this.boundOnHashChange = _this.onHashChange.bind(_this);
    var $tabList = _this.$module.querySelector('.govuk-tabs__list');
    var $tabListItems = _this.$module.querySelectorAll('li.govuk-tabs__list-item');
    if (!$tabList) {
      throw new ElementError({
        componentName: 'Tabs',
        identifier: 'List (`<ul class="govuk-tabs__list">`)'
      });
    }
    if (!$tabListItems.length) {
      throw new ElementError({
        componentName: 'Tabs',
        identifier: 'List items (`<li class="govuk-tabs__list-item">`)'
      });
    }
    _this.$tabList = $tabList;
    _this.$tabListItems = $tabListItems;
    _this.setupResponsiveChecks();
    return _this;
  }
  _inherits(Tabs, _GOVUKFrontendCompone);
  return _createClass(Tabs, [{
    key: "setupResponsiveChecks",
    value: function setupResponsiveChecks() {
      var _this2 = this;
      var breakpoint = getBreakpoint('tablet');
      if (!breakpoint.value) {
        throw new ElementError({
          componentName: 'Tabs',
          identifier: "CSS custom property (`".concat(breakpoint.property, "`) on pseudo-class `:root`")
        });
      }
      this.mql = window.matchMedia("(min-width: ".concat(breakpoint.value, ")"));
      if ('addEventListener' in this.mql) {
        this.mql.addEventListener('change', function () {
          return _this2.checkMode();
        });
      } else {
        this.mql.addListener(function () {
          return _this2.checkMode();
        });
      }
      this.checkMode();
    }
  }, {
    key: "checkMode",
    value: function checkMode() {
      var _this$mql;
      if ((_this$mql = this.mql) != null && _this$mql.matches) {
        this.setup();
      } else {
        this.teardown();
      }
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this3 = this;
      var _this$getTab;
      this.$tabList.setAttribute('role', 'tablist');
      this.$tabListItems.forEach(function ($item) {
        $item.setAttribute('role', 'presentation');
      });
      this.$tabs.forEach(function ($tab) {
        _this3.setAttributes($tab);
        $tab.addEventListener('click', _this3.boundTabClick, true);
        $tab.addEventListener('keydown', _this3.boundTabKeydown, true);
        _this3.hideTab($tab);
      });
      var $activeTab = (_this$getTab = this.getTab(window.location.hash)) != null ? _this$getTab : this.$tabs[0];
      this.showTab($activeTab);
      window.addEventListener('hashchange', this.boundOnHashChange, true);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var _this4 = this;
      this.$tabList.removeAttribute('role');
      this.$tabListItems.forEach(function ($item) {
        $item.removeAttribute('role');
      });
      this.$tabs.forEach(function ($tab) {
        $tab.removeEventListener('click', _this4.boundTabClick, true);
        $tab.removeEventListener('keydown', _this4.boundTabKeydown, true);
        _this4.unsetAttributes($tab);
      });
      window.removeEventListener('hashchange', this.boundOnHashChange, true);
    }
  }, {
    key: "onHashChange",
    value: function onHashChange() {
      var hash = window.location.hash;
      var $tabWithHash = this.getTab(hash);
      if (!$tabWithHash) {
        return;
      }
      if (this.changingHash) {
        this.changingHash = false;
        return;
      }
      var $previousTab = this.getCurrentTab();
      if (!$previousTab) {
        return;
      }
      this.hideTab($previousTab);
      this.showTab($tabWithHash);
      $tabWithHash.focus();
    }
  }, {
    key: "hideTab",
    value: function hideTab($tab) {
      this.unhighlightTab($tab);
      this.hidePanel($tab);
    }
  }, {
    key: "showTab",
    value: function showTab($tab) {
      this.highlightTab($tab);
      this.showPanel($tab);
    }
  }, {
    key: "getTab",
    value: function getTab(hash) {
      return this.$module.querySelector("a.govuk-tabs__tab[href=\"".concat(hash, "\"]"));
    }
  }, {
    key: "setAttributes",
    value: function setAttributes($tab) {
      var panelId = getFragmentFromUrl($tab.href);
      if (!panelId) {
        return;
      }
      $tab.setAttribute('id', "tab_".concat(panelId));
      $tab.setAttribute('role', 'tab');
      $tab.setAttribute('aria-controls', panelId);
      $tab.setAttribute('aria-selected', 'false');
      $tab.setAttribute('tabindex', '-1');
      var $panel = this.getPanel($tab);
      if (!$panel) {
        return;
      }
      $panel.setAttribute('role', 'tabpanel');
      $panel.setAttribute('aria-labelledby', $tab.id);
      $panel.classList.add(this.jsHiddenClass);
    }
  }, {
    key: "unsetAttributes",
    value: function unsetAttributes($tab) {
      $tab.removeAttribute('id');
      $tab.removeAttribute('role');
      $tab.removeAttribute('aria-controls');
      $tab.removeAttribute('aria-selected');
      $tab.removeAttribute('tabindex');
      var $panel = this.getPanel($tab);
      if (!$panel) {
        return;
      }
      $panel.removeAttribute('role');
      $panel.removeAttribute('aria-labelledby');
      $panel.classList.remove(this.jsHiddenClass);
    }
  }, {
    key: "onTabClick",
    value: function onTabClick(event) {
      var $currentTab = this.getCurrentTab();
      var $nextTab = event.currentTarget;
      if (!$currentTab || !($nextTab instanceof HTMLAnchorElement)) {
        return;
      }
      event.preventDefault();
      this.hideTab($currentTab);
      this.showTab($nextTab);
      this.createHistoryEntry($nextTab);
    }
  }, {
    key: "createHistoryEntry",
    value: function createHistoryEntry($tab) {
      var $panel = this.getPanel($tab);
      if (!$panel) {
        return;
      }
      var panelId = $panel.id;
      $panel.id = '';
      this.changingHash = true;
      window.location.hash = panelId;
      $panel.id = panelId;
    }
  }, {
    key: "onTabKeydown",
    value: function onTabKeydown(event) {
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
        case 'Left':
        case 'Up':
          this.activatePreviousTab();
          event.preventDefault();
          break;
        case 'ArrowRight':
        case 'ArrowDown':
        case 'Right':
        case 'Down':
          this.activateNextTab();
          event.preventDefault();
          break;
      }
    }
  }, {
    key: "activateNextTab",
    value: function activateNextTab() {
      var $currentTab = this.getCurrentTab();
      if (!($currentTab != null && $currentTab.parentElement)) {
        return;
      }
      var $nextTabListItem = $currentTab.parentElement.nextElementSibling;
      if (!$nextTabListItem) {
        return;
      }
      var $nextTab = $nextTabListItem.querySelector('a.govuk-tabs__tab');
      if (!$nextTab) {
        return;
      }
      this.hideTab($currentTab);
      this.showTab($nextTab);
      $nextTab.focus();
      this.createHistoryEntry($nextTab);
    }
  }, {
    key: "activatePreviousTab",
    value: function activatePreviousTab() {
      var $currentTab = this.getCurrentTab();
      if (!($currentTab != null && $currentTab.parentElement)) {
        return;
      }
      var $previousTabListItem = $currentTab.parentElement.previousElementSibling;
      if (!$previousTabListItem) {
        return;
      }
      var $previousTab = $previousTabListItem.querySelector('a.govuk-tabs__tab');
      if (!$previousTab) {
        return;
      }
      this.hideTab($currentTab);
      this.showTab($previousTab);
      $previousTab.focus();
      this.createHistoryEntry($previousTab);
    }
  }, {
    key: "getPanel",
    value: function getPanel($tab) {
      var panelId = getFragmentFromUrl($tab.href);
      if (!panelId) {
        return null;
      }
      return this.$module.querySelector("#".concat(panelId));
    }
  }, {
    key: "showPanel",
    value: function showPanel($tab) {
      var $panel = this.getPanel($tab);
      if (!$panel) {
        return;
      }
      $panel.classList.remove(this.jsHiddenClass);
    }
  }, {
    key: "hidePanel",
    value: function hidePanel($tab) {
      var $panel = this.getPanel($tab);
      if (!$panel) {
        return;
      }
      $panel.classList.add(this.jsHiddenClass);
    }
  }, {
    key: "unhighlightTab",
    value: function unhighlightTab($tab) {
      if (!$tab.parentElement) {
        return;
      }
      $tab.setAttribute('aria-selected', 'false');
      $tab.parentElement.classList.remove('govuk-tabs__list-item--selected');
      $tab.setAttribute('tabindex', '-1');
    }
  }, {
    key: "highlightTab",
    value: function highlightTab($tab) {
      if (!$tab.parentElement) {
        return;
      }
      $tab.setAttribute('aria-selected', 'true');
      $tab.parentElement.classList.add('govuk-tabs__list-item--selected');
      $tab.setAttribute('tabindex', '0');
    }
  }, {
    key: "getCurrentTab",
    value: function getCurrentTab() {
      return this.$module.querySelector('.govuk-tabs__list-item--selected a.govuk-tabs__tab');
    }
  }]);
}(GOVUKFrontendComponent);
Tabs.moduleName = 'govuk-tabs';
export { Tabs };